import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ToggleValue } from 'components/Admin/Shared/Toggle'
import { Affiliate } from 'types'

type InitialState = {
  contactEmail?: { toggle?: ToggleValue; value?: string }
  website?: { toggle?: ToggleValue; value?: string }
  address?: { toggle?: ToggleValue; value?: string }
  phone?: { toggle?: ToggleValue; value?: string }
}

const initialState: InitialState = {
  contactEmail: {},
  website: {},
  address: {},
  phone: {},
}

export const basicInfoSlice = createSlice({
  name: 'basicInfo',
  initialState: initialState,
  reducers: {
    updateContactEmail: (
      state,
      action: PayloadAction<{ toggleValue?: ToggleValue; value?: string }>,
    ) => {
      if (action.payload.value) {
        state.contactEmail.value = action.payload.value
      }

      if (action.payload.toggleValue) {
        state.contactEmail.toggle = action.payload.toggleValue
      }

      return state
    },
    updateWebsite: (
      state,
      action: PayloadAction<{ toggleValue?: ToggleValue; value?: string }>,
    ) => {
      if (action.payload.value) {
        state.website.value = action.payload.value
      }

      if (action.payload.toggleValue) {
        state.website.toggle = action.payload.toggleValue
      }

      return state
    },
    updateAddress: (
      state,
      action: PayloadAction<{ toggleValue?: ToggleValue; value?: string }>,
    ) => {
      if (action.payload.value) {
        state.address.value = action.payload.value
      }

      if (action.payload.toggleValue) {
        state.address.toggle = action.payload.toggleValue
      }

      return state
    },
    updatePhone: (
      state,
      action: PayloadAction<{ toggleValue?: ToggleValue; value?: string }>,
    ) => {
      if (action.payload.value) {
        state.phone.value = action.payload.value
      }

      if (action.payload.toggleValue) {
        state.phone.toggle = action.payload.toggleValue
      }

      return state
    },
    updateAll: (state, action: PayloadAction<Affiliate>) => {
      const affiliate = action.payload

      state.contactEmail.toggle = affiliate.settings['contactEmail']['isPublic']
        ? ToggleValue.PUBLIC
        : ToggleValue.PRIVATE
      state.contactEmail.value = affiliate.contactEmail

      state.website.toggle = affiliate.settings['web']['isPublic']
        ? ToggleValue.PUBLIC
        : ToggleValue.PRIVATE
      state.website.value = affiliate.web

      state.address.toggle = affiliate.settings['address']['isPublic']
        ? ToggleValue.PUBLIC
        : ToggleValue.PRIVATE
      state.address.value = affiliate.address1

      state.phone.toggle = affiliate.settings['contactPhone']['isPublic']
        ? ToggleValue.PUBLIC
        : ToggleValue.PRIVATE
      state.phone.value = affiliate.contactPhone

      return state
    },
    updateBio: (
      state,
      action: PayloadAction<{ toggleValue?: ToggleValue; value?: string }>,
    ) => {
      if (action.payload.value) {
        state.phone.value = action.payload.value
      }

      if (action.payload.toggleValue) {
        state.phone.toggle = action.payload.toggleValue
      }

      return state
    },
  },
})

export const {
  updateContactEmail,
  updateWebsite,
  updateAddress,
  updatePhone,
  updateAll,
} = basicInfoSlice.actions
export default basicInfoSlice.reducer
